export default {
  defaultProps: {
    colorScheme: "brandPrimary",
  },
};
